export const LOAD_AUTHENTICATIONTOKEN_LOADING = 'REDUX_SAGA_LOAD_AUTHENTICATIONTOKEN_LOADING';
export const LOAD_AUTHENTICATIONTOKEN_SUCCESS = 'REDUX_SAGA_LOAD_AUTHENTICATIONTOKEN_SUCCESS';
export const LOAD_AUTHENTICATIONTOKEN_ERROR = 'REDUX_SAGA_LOAD_AUTHENTICATIONTOKEN_ERROR';

export const actionLoadAuthenticationToken = (dispatch) => {
  dispatch({ type: LOAD_AUTHENTICATIONTOKEN_LOADING });
};
